import { render } from "./GeoStati.vue?vue&type=template&id=a8b36586&scoped=true"
import script from "./GeoStati.vue?vue&type=script&lang=js"
export * from "./GeoStati.vue?vue&type=script&lang=js"

import "./GeoStati.vue?vue&type=style&index=0&id=a8b36586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b36586"]])

export default __exports__